import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Bind } from 'primeng/bind';
import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Bind, ConfirmDialog],
})
export class ConfirmDialogComponent {}
